var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require('editor-2d');
var IpcImages = require("../../../../shared/extensions/footprintGenerator/ipcImages/index.js");
if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var IpcSmdPadGeneratorWithThermalPadInteractionModel = require('./ipcSmdPadGeneratorWithThermalPadInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");

var QuadRowPackageGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorWithThermalPadInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(QuadRowPackageGeneratorInteractionModel, IpcSmdPadGeneratorWithThermalPadInteractionModel);
QuadRowPackageGeneratorInteractionModel.$class = 'QuadRowPackageGeneratorInteractionModel';

module.exports = QuadRowPackageGeneratorInteractionModel;

QuadRowPackageGeneratorInteractionModel.prototype.initialize = function() {
	var self = this;

	IpcSmdPadGeneratorWithThermalPadInteractionModel.prototype.initialize.call(this);

	this.verticalPadCount = this.shadow("verticalPadCount",
        function() {
            return self.data.verticalPadCount();
        },
        function(value) {
            value = parseInt(value);
            
            //pad count should not be zero
            if(value === 0) return false;

            var status = self.data.verticalPadCount(value);
            self.updateNameList();
            return status;
        },
        [self.data.verticalPadCount, this.userSettingsModel.distanceUnit]
    );

    this.verticalLeadToLeadSpanMin = this.shadow("verticalLeadToLeadSpanMin",
        function() {
            return self.data.verticalLeadToLeadSpanMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.verticalLeadToLeadSpanMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.verticalLeadToLeadSpanMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.verticalLeadToLeadSpanMax = this.shadow("verticalLeadToLeadSpanMax",
        function() {
            return self.data.verticalLeadToLeadSpanMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.verticalLeadToLeadSpanMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.verticalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit
        ]
    );
};

QuadRowPackageGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    var dPins = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#DPins', '# Pins (D Side)'), this.horizontalPadCount);
    var ePins = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#EPins', '# Pins (E side)'), this.verticalPadCount);

    return [dPins, ePins];
};

QuadRowPackageGeneratorInteractionModel.prototype.getInspectorElementForLeadSpan = function() {
    var span1 = PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('leadSpan1', 'Lead Span 1'), false, this.verticalLeadToLeadSpanMin, false, this.verticalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit);
    var span2 = PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('leadSpan2', 'Lead Span 2'), false, this.horizontalLeadToLeadSpanMin, false, this.horizontalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit);

    return [span1, span2];
};

QuadRowPackageGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E1', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

QuadRowPackageGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D1', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};


QuadRowPackageGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintQuadPackage));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadSpan1InCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadSpan2InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementsForThermalPadSettings());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};